/** Title-case amenity labels for display (e.g. "swimming pool" → "Swimming Pool"). */
export function toTitleCaseAmenity(value: string): string {
  return value
    .toLowerCase()
    .replace(/(^|[\s/&-])([a-z])/g, (_, boundary: string, char: string) => boundary + char.toUpperCase());
}
